var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventReviewQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Different sizes"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 14,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon / quotes",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1147 10.4335C11.4426 12.4546 13.2389 14 15.4056 14C17.8049 14 19.75 12.105 19.75 9.76738C19.75 7.49129 17.906 5.63481 15.594 5.53868L15.5785 5.539L18.9863 1.70066L17.0504 0L16.8103 0.260636L12.377 5.40364C11.2178 6.93903 10.7804 8.64077 11.1031 10.4356L11.1147 10.4335ZM0.61467 10.4335C0.942608 12.4546 2.73886 14 4.90559 14C7.30494 14 9.25 12.105 9.25 9.76738C9.25 7.49129 7.40597 5.63481 5.09404 5.53868L5.0785 5.539L8.48628 1.70066L6.55042 0L1.87704 5.40364C0.717838 6.93903 0.280416 8.64077 0.603119 10.4356L0.61467 10.4335Z",
    fill: "#E8EAED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventReviewQuotes);
export default __webpack_public_path__ + "static/media/event_review_quotes.6047453858f23bc8e689f7a8f5b1ecd9.svg";
export { ForwardRef as ReactComponent };